<div class="set-password-wrapper">
    <div class="set-password-header">
        <button *ngIf="mode !== 'create'" type="button" class="back-button" (click)="onBackClick()">
            <i class="bi bi-chevron-left"></i>
            {{ 'FORGOT_PASSWORD.BACK' | translate }}
        </button>
        <h1 class="set-password-title">{{ (mode === 'create' ? 'CREATE_PASSWORD.TITLE' : 'SET_NEW_PASSWORD.TITLE') |
            translate }}</h1>
        <p class="set-password-subtitle">{{ (mode === 'create' ? 'CREATE_PASSWORD.SUBTITLE' :
            'SET_NEW_PASSWORD.SUBTITLE') | translate }}</p>
    </div>

    <!-- Toast Notification -->
    <app-toast class="toast-wrapper"></app-toast>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="set-password-form">
        <!-- New Password Field -->
        <div class="form-group">
            <label class="form-label">
                <span class="required-asterisk">*</span>
                {{ (mode === 'create' ? 'CREATE_PASSWORD.PASSWORD_LABEL' : 'SET_NEW_PASSWORD.PASSWORD_LABEL') |
                translate }}
            </label>
            <div class="input-wrapper">
                <input [type]="showPassword ? 'text' : 'password'" class="form-control"
                    [class.is-invalid]="f['newPassword'].touched && f['newPassword'].errors"
                    [placeholder]="(mode === 'create' ? 'CREATE_PASSWORD.PASSWORD_PLACEHOLDER' : 'SET_NEW_PASSWORD.PASSWORD_PLACEHOLDER') | translate"
                    formControlName="newPassword">
                <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
                    <i class="bi" [class.bi-eye]="showPassword" [class.bi-eye-slash]="!showPassword"></i>
                </button>
            </div>

            <!-- Password Requirements -->
            <ul class="password-requirements">
                <li [class.valid]="passwordValidations.length">
                    <span [inlineSVG]="'./assets/icons/Content/icon-med-circle-check.svg'"
                        class="svg-icon icon-sm"></span>
                    {{ 'VALIDATION.PASSWORD_MIN_LENGTH' | translate }}
                </li>
                <li [class.valid]="passwordValidations.upper">
                    <span [inlineSVG]="'./assets/icons/Content/icon-med-circle-check.svg'"
                        class="svg-icon icon-sm"></span>
                    {{ 'VALIDATION.PASSWORD_UPPERCASE' | translate }}
                </li>
                <li [class.valid]="passwordValidations.lower">
                    <span [inlineSVG]="'./assets/icons/Content/icon-med-circle-check.svg'"
                        class="svg-icon icon-sm"></span>
                    {{ 'VALIDATION.PASSWORD_LOWERCASE' | translate }}
                </li>
                <li [class.valid]="passwordValidations.number">
                    <span [inlineSVG]="'./assets/icons/Content/icon-med-circle-check.svg'"
                        class="svg-icon icon-sm"></span>
                    {{ 'VALIDATION.PASSWORD_NUMBER' | translate }}
                </li>
                <li [class.valid]="passwordValidations.special">
                    <span [inlineSVG]="'./assets/icons/Content/icon-med-circle-check.svg'"
                        class="svg-icon icon-sm"></span>
                    {{ 'VALIDATION.PASSWORD_SPECIAL' | translate }}
                </li>
            </ul>
        </div>

        <!-- Confirm Password Field -->
        <div class="form-group">
            <label class="form-label">
                <span class="required-asterisk">*</span>
                {{ (mode === 'create' ? 'CREATE_PASSWORD.CONFIRM_LABEL' : 'SET_NEW_PASSWORD.CONFIRM_LABEL') | translate
                }}
            </label>
            <div class="input-wrapper">
                <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"
                    [class.is-invalid]="f['confirmPassword'].touched && f['confirmPassword'].errors"
                    [placeholder]="(mode === 'create' ? 'CREATE_PASSWORD.CONFIRM_PLACEHOLDER' : 'SET_NEW_PASSWORD.CONFIRM_PLACEHOLDER') | translate"
                    formControlName="confirmPassword">
                <button type="button" class="toggle-password" (click)="toggleConfirmPasswordVisibility()">
                    <i class="bi" [class.bi-eye]="showConfirmPassword" [class.bi-eye-slash]="!showConfirmPassword"></i>
                </button>
            </div>
            <div class="invalid-feedback"
                *ngIf="f['confirmPassword'].touched && f['confirmPassword'].errors?.['required']">
                {{ 'VALIDATION.PASSWORD_REQUIRED' | translate }}
            </div>
            <div class="invalid-feedback"
                *ngIf="f['confirmPassword'].touched && f['confirmPassword'].errors?.['passwordMismatch']">
                {{ 'VALIDATION.PASSWORD_MISMATCH' | translate }}
            </div>
        </div>

        <button type="submit" class="btn-submit" [disabled]="form.invalid || isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ (mode === 'create' ? 'CREATE_PASSWORD.SUBMIT_BUTTON' : 'SET_NEW_PASSWORD.SUBMIT_BUTTON') | translate }}
        </button>
    </form>
</div>


<!-- Success Modal using CommonModalComponent -->
<app-common-modal #successModal [modalClass]="'success-modal-content'"
    [commonModalConfig]="{header: false, body: true, footer: true}">
    <ng-container ModalBody>
        <div class="pt-5 pb-5 text-left">
            <div class="d-flex flex-column align-items-start mb-4">
                <div class="mb-4 success-icon-wrapper">
                    <span [inlineSVG]="'./assets/icons/Content/icon-med-circle-check.svg'"
                        class="svg-icon text-success"></span>
                </div>
                <div>
                    <h2 class="fw-bolder mb-1">{{ (mode === 'create' ? 'CREATE_PASSWORD.SUCCESS_MODAL.TITLE' :
                        'SET_NEW_PASSWORD.SUCCESS_MODAL.TITLE') | translate }}</h2>
                    <p class="text-gray-600 fs-5 mb-0">{{ (mode === 'create' ? 'CREATE_PASSWORD.SUCCESS_MODAL.MESSAGE' :
                        'SET_NEW_PASSWORD.SUCCESS_MODAL.MESSAGE') | translate }}</p>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container ModalFooter>
        <div class="d-flex justify-content-end w-100">
            <button type="button" class="btn btn-primary" (click)="successModal.close(null); onModalClose()">
                {{ (mode === 'create' ? 'CREATE_PASSWORD.SUCCESS_MODAL.BUTTON' :
                'SET_NEW_PASSWORD.SUCCESS_MODAL.BUTTON') |
                translate }}
            </button>
        </div>
    </ng-container>
</app-common-modal>